module.exports = __webpack_public_path__ + "static/media/printing-services-img8.847bdda4.jpg";